// URL Query Parameters Constants
export const URL_PARAMS = {
  // User authentication parameters
  USER: 'user',
  CARTA: 'carta',
  TOKEN: 'token',
  
  // App configuration parameters
  STATIC_DATA: 'staticData',
  TAB: 'tab',
  MENU: 'menu',
  
  // Game launch parameters
  GAME_NAME: 'gameName',
  LAUNCH_CODE: 'launchCode',
  PARTNER_ID: 'partnerID',
  PLATFORM_ID: 'platformID',
  
  // WebView parameter
  WEB_VIEW: 'webView',
  
  // Frontend type parameter
  TIPO_FRONTEND: 'tipo_frontend'
} as const;

// Type for URL parameter keys
export type UrlParamKey = typeof URL_PARAMS[keyof typeof URL_PARAMS];